import { action } from 'satcheljs';
import { IFilterPanelProps } from '../../AdReview/AdCreativePage.types';

export const onFilterPanelShown = action('onFilterPanelShown', (filterPanel: IFilterPanelProps) => ({
  filterPanel,
}));

export const onFilterPanelHide = action('onFilterPanelHide');
